export default function SectionTitle({ kicker, title, children }) {
  return (
    <div className="mb-12 md:mb-16 max-w-3xl">
      <p className="text-[11px] tracking-[0.4em] text-tan mb-4 font-display">{kicker}</p>
      <h2 className="font-display text-3xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-white via-slate-200 to-indigo-400 leading-tight">{title}</h2>
      <div className="rule-ornament mt-5 max-w-xs"><i /></div>
      {children && <p className="mt-5 text-slate-400 text-base">{children}</p>}
    </div>
  );
}
